import { PublicKey, Connection } from '@solana/web3.js';
import { Metaplex } from "@metaplex-foundation/js";
import { delay } from '../utils';
const connection = new Connection(process.env.REACT_APP_RPC_URL);
const metaplex = new Metaplex(connection);
export async function fetchNFTsOnchain(walletAddress, delaytime=0) {
  console.log('waiting ')
  await delay(delaytime)
  console.log('waiting end')
  const walletPublicKey = new PublicKey(walletAddress);
  console.log("allNFTs");
  const allNFTs = await metaplex.nfts().findAllByOwner({owner:walletPublicKey});
  console.log(allNFTs);
  const nfts = [];
  await Promise.all(allNFTs.map(async (nft)=>{
    if(nft.symbol !== 'ANTS') return
    const nftMetadata = await metaplex.nfts().findByMint({ mintAddress: nft.mintAddress });
    nfts.push({
      mint: nft.mintAddress.toString(),
      metadata: nftMetadata.json, // Includes the full metadata, can extract image URL, etc., here.
    });
  }))
  return nfts;
}

export async function fetchAntcloinOnchain(){
  try {
      const associatedAddress = new PublicKey('DpX1akWHwE9qrKzxHoD5v3QZWECqK2Hhga4wpcbi1xwh');

      const balance = await connection.getTokenAccountBalance(associatedAddress);
      return {
          success: true,
          balance: balance.value.uiAmount
      };
  } catch (error) {
      console.error('Error fetching token balance:', error);
     return ({ success: false, message: 'Failed to fetch token balance', error: error.toString() });
  }
}